export default __webpack_public_path__ + "static/media/new-icon.79f3eeaf.svg";